namespace Gamification.Gamification {
    export interface UtentiDelegatiForm {
        UserId: Serenity.IntegerEditor;
        UserIdDelDelegato: Serenity.IntegerEditor;
    }

    export class UtentiDelegatiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiDelegati';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiDelegatiForm.init)  {
                UtentiDelegatiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(UtentiDelegatiForm, [
                    'UserId', w0,
                    'UserIdDelDelegato', w0
                ]);
            }
        }
    }
}
